import React, { useEffect, useState } from "react";
import api from "../lib/api";
import VendorCard from "../components/VendorCard";
import PostcodeFilter from "../components/PostcodeFilter";
import { useCart } from "../lib/cart";

const ORIGINS = ["All", "Nigerian", "Ghanaian", "Kenyan", "Zimbabwean", "Southern African", "East African", "Caribbean"];

export default function VendorList() {
  const { postcode } = useCart();
  const [vendors, setVendors] = useState([]);
  const [origin, setOrigin] = useState("All");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const params = new URLSearchParams();
        if (postcode) params.set("postcode", postcode);
        if (origin !== "All") params.set("cultural_origin", origin);
        const { data } = await api.get(`/vendors?${params.toString()}`);
        setVendors(data);
      } catch (err) { /* eslint-disable-next-line no-console */ console.warn("[VendorList] non-fatal error:", err); }
      setLoading(false);
    })();
  }, [origin, postcode]);

  return (
    <div className="pt-24 pb-24 max-w-7xl mx-auto px-4 md:px-8 lg:px-12" data-testid="vendors-page">
      <div className="mb-8">
        <p className="text-xs font-bold tracking-[0.15em] uppercase text-[#A94438] mb-1">Our community</p>
        <h1 className="font-heading text-3xl md:text-5xl font-black tracking-tighter mb-4">Trusted UK vendors</h1>
        <p className="text-sm text-[#5C5C54] max-w-xl">Every vendor is hand-verified. Only those delivering to your postcode appear when you set it below.</p>
      </div>

      <div className="flex flex-col md:flex-row gap-3 mb-6">
        <div className="md:w-80"><PostcodeFilter /></div>
        <div className="flex items-center gap-2 overflow-x-auto no-scrollbar pb-1">
          {ORIGINS.map((o) => (
            <button
              key={o}
              data-testid={`origin-filter-${o.toLowerCase().replace(/\s/g, "-")}`}
              onClick={() => setOrigin(o)}
              className={`whitespace-nowrap rounded-full px-4 py-2 text-xs font-bold transition-all ${o === origin ? "bg-[#1A1A18] text-white" : "bg-white border border-[#E5E2D9] text-[#5C5C54] hover:border-[#D1CEC5]"}`}
            >
              {o}
            </button>
          ))}
        </div>
      </div>

      {postcode && (
        <p className="text-xs text-[#5C5C54] mb-4">Showing vendors that deliver to <span className="font-bold text-[#1A1A18]">{postcode}</span>.</p>
      )}

      {loading ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {[0, 1, 2].map((i) => <div key={i} className="h-80 bg-white rounded-2xl animate-pulse border border-[#E5E2D9]" />)}
        </div>
      ) : vendors.length === 0 ? (
        <div className="card-surface p-10 text-center" data-testid="no-vendors-message">
          <p className="text-sm text-[#5C5C54]">No vendors found for those filters. Try another postcode.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {vendors.map((v) => <VendorCard key={v.vendor_id} vendor={v} />)}
        </div>
      )}
    </div>
  );
}
